import { ReactNode } from 'react';

export interface DocumentType {
  pdfUrl?: string;
  customerId?: string;
  documentId?: string;
  version?: string;
  state?: string;
  text?: string;
  audioCreated?: string;
  created?: string;
  language?: string;
  speechParams?: SpeechParamsTypeObject;
  autoUpdated?: boolean;
  externalUrl?: string;
  description?: string;
  isDocFromMp3?: boolean;
  title?: string;
  audioGenerations?: HistoryAudioType[];
  documentRevisions?: HistoryDocumentType[];
  publicationYear?: number;
  publicationLocation?: string;
  author?: string;
  publisher?: string;
}

export interface SpeechParamsType {
  languageCode?: string;
  voiceId?: string;
  engine?: string;
  domain?: string;
  sampleRate?: number;
  prosodyRate?: number;
}

export interface ButtonPropsType {
  type: string;
  onClick: () => void;
  children?: ReactNode;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export interface AudioPreviewerType {
  id: string;
  text: string;
  document?: DocumentType;
  autoplay: boolean;
}

export interface UserData {
  sub: string;
  email_verified: boolean;
  name: string;
  email: string;
}

export interface FiltersType {
  start: Date;
  end: Date;
  channels: string[];
  subchannels: string[];
}

export interface TopFiles {
  consumption: string;
  documentId: string;
  downloads: number;
}

export interface TopChannels {
  channel: string;
  subchannel: string;
  userCount: number;
  documentCount: number;
}

export interface TopUsers {
  userId: string;
  uniqueFiles: string;
  downloads: string;
}

export interface DailyResults {
  day: string;
  uniqueUsers: string;
  uniqueFiles: string;
  downloads: string;
}

export interface TableHeaderColumns {
  title: string;
  value: string;
}

export interface AnalyticsState {
  topFiles: TopFiles[];
  topUsers: TopUsers[];
  topChannels: TopChannels[];
  dailyResults: DailyResults[];
  publishedDocuments: DocumentType[];
}

export interface ErrorState {
  errorMessage: string;
  hasError: boolean;
}

export interface ReplacementType {
  replacementId: number;
  pattern: string;
  replacement: string;
  category: string;
  order: number;
  created: number;
  sample: string;
  comments: string;
  username: string;
}

export interface AcronymsType {}

export class ReplacementTypeObject implements ReplacementType {
  replacementId: number = 0;
  pattern: string = '';
  replacement: string = '';
  category: string = '';
  order: number = 0;
  created: number = 0;
  sample: string = '';
  comments: string = '';
  username: string = '';
}

export class SpeechParamsTypeObject implements SpeechParamsType {
  languageCode: string = '';
  voiceId: string = '';
  engine: string = '';
  domain: string = '';
  sampleRate: number = 0;
  prosodyRate: number = 0;
  provider?: string = '';
}
export class DocumentTypeObject implements DocumentType {
  customerId: string = '';
  documentId: string = '';
  version: string = '';
  state: string = '';
  text: string = '';
  audioCreated: string = '';
  created: string = '';
  speechParams: SpeechParamsTypeObject = new SpeechParamsTypeObject();
  autoUpdated?: boolean = false;
  externalUrl?: string = '';
  description?: string = '';
}
export interface JobType {
  id: string | undefined;
  name: string;
  rssUrl: string;
  schedule: string;
}

export class JobTypeObject implements JobType {
  id: string = '';
  name: string = '';
  rssUrl: string = '';
  schedule: string = '';
}
export interface PodcastType {
  id: string;
  author: string;
  title: string;
  category: string;
  language: string;
  publisher: string;
  description: string;
  type: string;
  parser: string;
  imageUrl: string;
  contentType: number;
  numPublishedEpisode: number;
  numTotalEpisode: number;
  eposodesOrderList: string[];
  groups: string[];
  publicationLocation: string;
  publicationYear: string;
  voiceSettings: string;
  created: string;
  url: string;
  priority: number;
  retrieval: boolean;
}

export interface UrlType {
  documentId: string | undefined;
  customerId: string;
  description: string;
  mp3url: string;
}

export class UrlTypeObject implements UrlType {
  documentId: string = '';
  customerId: string = '';
  description: string = '';
  mp3url: string = '';
}

export interface UserInfoType {
  username: string;
  isAdmin: boolean;
  permissions: string[];
}

export class UserInfoTypeObject implements UserInfoType {
  username: string = '';
  isAdmin: boolean = false;
  permissions: string[] = [];
}
export interface UserType {
  username: string;
  customers: string[];
  permissions: string[];
}

export class UserTypeObject implements UserType {
  username: string = '';
  customers: string[] = [];
  permissions: string[] = [];
}
export interface GroupType {
  groupId: string;
  customers: string[];
  permissions: string[];
  actions: string[];
}

export class GroupTypeObject implements GroupType {
  groupId: string = '';
  customers: string[] = [];
  permissions: string[] = [];
  actions: string[] = [];
}

export interface ImagesOfDocument {
  id: any;
  name: string;
  url?: string;
  file?: File;
  width?: number;
  height?: number;
}

export interface HistoryAudioType {
  version: number;
  username: string;
  created: string;
  autoDeployed: boolean;
}

export interface HistoryDocumentType {
  revision: number;
  username: string;
  date: string;
}

export type OrderType = 'asc' | 'desc';
